import { jsx } from "react/jsx-runtime";
import { createContext } from "react";
import { BindingError } from "@contember/binding";
const ReferencesContext = createContext(() => {
  throw new BindingError();
});
const ReferencesProvider = ({ children, getReferencedEntity }) => {
  return /* @__PURE__ */ jsx(ReferencesContext.Provider, { value: getReferencedEntity, children });
};
export {
  ReferencesContext,
  ReferencesProvider
};
//# sourceMappingURL=ReferencesProvider.js.map
